<template>
  <InstagramToolPage
    h1-title="Instagram IGTV Downloader"
    subtitle="Try to save older long-form videos from legacy IGTV or /tv/ links when they are still public."
    input-placeholder="Paste Instagram /tv/ or video post URL"
    action-label="Download"
    limitation-note="IGTV merged into Instagram Video in 2021. Legacy links only when still accessible."
    current-tool-path="/instagram-igtv-downloader/"
    :faqs="faqs"
  >
    <ToolContentSections :sections="igtvDownloaderSections" />
  </InstagramToolPage>
</template>

<script>
import InstagramToolPage from '@/components/InstagramToolPage.vue';
import ToolContentSections from '@/components/ToolContentSections.vue';
import { igtvDownloaderSections } from '@/data/instagram-tool-page-content';

export default {
  name: 'InstagramIgtvDownloaderPage',
  components: { InstagramToolPage, ToolContentSections },
  data () {
    return {
      igtvDownloaderSections,
      faqs: [
        {
          question: 'Is IGTV still a thing on Instagram?',
          answer: 'Not as a standalone product. Meta merged IGTV into Instagram Video in 2021. The name survives in old links and search queries.',
        },
        {
          question: 'Can you download every old IGTV video?',
          answer: 'Only if Instagram still serves public media for that URL. Many legacy links no longer work.',
        },
        {
          question: 'What should I use for new long videos?',
          answer: 'Copy the link from the creator’s current Instagram post or Reel and use the appropriate SnapInsta tool.',
        },
        {
          question: 'Does SnapInsta work with Meta or Instagram?',
          answer: 'SnapInsta is an independent tool and is not affiliated with Instagram or Meta.',
        },
      ],
    };
  },
};
</script>
